import { environment } from '../../../environments/environment';

/**
 * Pleiades CDN base URL for accessing global static assets.
 *
 * This constant provides a single source of truth for the Pleiades CDN URL across therapy-essentials.
 * The CDN URL is environment-specific, allowing you to test with local, staging, or production CDN instances.
 *
 * The CDN is organized by asset type and service:
 * - CSS: `/css/common/` or `/css/therapy-essentials/`
 * - Images: `/images/common/` or `/images/therapy-essentials/`
 * - JavaScript: `/js/common/` or `/js/therapy-essentials/`
 *
 * ## Global Styles
 * Global CDN styles are loaded in `src/main.ts` before Angular bootstraps:
 *
 * ```typescript
 * import { CDN_URL } from '@common/constant/cdn';
 *
 * const cdnStylesheets = [
 *   '/css/common/colors.css',
 *   '/css/common/typography.css',
 *   '/css/common/utils.css',
 * ];
 *
 * cdnStylesheets.forEach((stylesheet) => {
 *   const link = document.createElement('link');
 *   link.rel = 'stylesheet';
 *   link.href = `${CDN_URL}${stylesheet}`;
 *   document.head.appendChild(link);
 * });
 * ```
 *
 * ## Assets
 * Use CDN_URL to reference images and other assets:
 *
 * ```typescript
 * import { CDN_URL } from '@common/constant/cdn';
 *
 * export class MyComponent {
 *   logoUrl = `${CDN_URL}/images/common/logo.png`;
 * }
 * ```
 *
 * @see https://github.com/presencelearning/pleiades-cdn - CDN Repository
 */
export const CDN_URL = environment.cdn_url;
